var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 24V15.3095C9.33333 14.6518 9.33333 14.3229 9.46655 14.0717C9.58373 13.8507 9.7707 13.6711 10.0007 13.5585C10.2621 13.4305 10.6044 13.4305 11.2889 13.4305H14.7111C15.3956 13.4305 15.7379 13.4305 15.9993 13.5585C16.2293 13.6711 16.4163 13.8507 16.5335 14.0717C16.6667 14.3229 16.6667 14.6518 16.6667 15.3095V24M11.7994 2.58385L3.50992 8.7789C2.9558 9.19302 2.67874 9.40007 2.47914 9.65938C2.30234 9.88908 2.17062 10.1478 2.09048 10.423C2 10.7335 2 11.0708 2 11.7453V20.242C2 21.5574 2 22.2151 2.26643 22.7175C2.50079 23.1595 2.87474 23.5188 3.33469 23.744C3.85759 24 4.54209 24 5.91111 24H20.0889C21.4579 24 22.1424 24 22.6653 23.744C23.1253 23.5188 23.4992 23.1595 23.7336 22.7175C24 22.2151 24 21.5574 24 20.242V11.7453C24 11.0708 24 10.7335 23.9095 10.423C23.8294 10.1478 23.6977 9.88908 23.5209 9.65938C23.3213 9.40007 23.0442 9.19302 22.4901 8.7789L14.2006 2.58385C13.7712 2.26295 13.5565 2.10249 13.3194 2.04082C13.1102 1.98639 12.8898 1.98639 12.6806 2.04082C12.4435 2.10249 12.2288 2.26295 11.7994 2.58385Z",
    stroke: "#252525",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeOutline);
export default __webpack_public_path__ + "static/media/home-outline.4ccd5386037198d0ea2248f5c584611b.svg";
export { ForwardRef as ReactComponent };